import React from "react";
import { observer } from "mobx-react";

const STEPS = [
  {
    num: "1",
    icon: "tune",
    title: "Set your filters",
    desc: "Filter by job title, company size, location, industry, seniority, technologies, and more."
  },
  {
    num: "2",
    icon: "search",
    title: "Browse results",
    desc: "Matching contacts and companies appear instantly. Refine filters to zero in on your ICP."
  },
  {
    num: "3",
    icon: "send",
    title: "Add or export",
    desc: "Save to a list, export as CSV, or launch a Salesgear campaign directly from the results."
  }
];

const NoFilterApplied = () => {
  return (
    <div className="noFilters listBuilderInitial">
      <div className="lbEmpty">
        <div className="lbEmptyHero">
          <div className="lbEmptyIconWrap" aria-hidden="true">
            <span className="material-symbols-outlined">person_search</span>
          </div>
          <h1 className="lbEmptyTitle">Find your next customer</h1>
          <p className="lbEmptySubtitle">
            Use the filters on the left to search our database of{" "}
            <strong>800M+ verified contacts</strong> and{" "}
            <strong>70M+ companies</strong> worldwide.
          </p>
          <div className="lbEmptyStats" aria-label="Database size">
            <div className="lbEmptyStat">
              <span className="lbEmptyStatValue">800M+</span>
              <span className="lbEmptyStatLabel">Contacts</span>
            </div>
            <div className="lbEmptyStatDivider" aria-hidden="true" />
            <div className="lbEmptyStat">
              <span className="lbEmptyStatValue">70M+</span>
              <span className="lbEmptyStatLabel">Companies</span>
            </div>
          </div>
        </div>
        <div className="lbEmptySteps">
          <p className="lbEmptyStepsHeading">How it works</p>
          <div className="lbEmptyStepsList">
            {STEPS.map((step, i) => (
              <React.Fragment key={i}>
                <div className="lbEmptyStep">
                  <div className="lbEmptyStepHeader">
                    <span className="lbEmptyStepNum">{step.num}</span>
                    <span className="material-symbols-outlined lbEmptyStepIcon" aria-hidden="true">{step.icon}</span>
                  </div>
                  <h3 className="lbEmptyStepTitle">{step.title}</h3>
                  <p className="lbEmptyStepDesc">{step.desc}</p>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="lbEmptyStepArrow" aria-hidden="true">
                    <span className="material-symbols-outlined">chevron_right</span>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export { NoFilterApplied };
export default observer(NoFilterApplied);
